export const environment = {
  production: true,
  apiBaseUrl: 'https://api.grahal.fr/',
  frontUrl: 'https://grahal.fr/',
  storagePath: 'https://api.grahal.fr/storage/'
}
